import { useNavigate } from 'react-router-dom';

const SchoolSupportSection = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const handleNavigateToMaintenance = () => {
    navigate('/maintenance-service');
  };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">
            購入から運用まで、すべてお任せください
          </h2>
          <p className="text-xl sm:text-lg text-gray-600">
            製品販売だけでなく、人材育成からアフターサポートまで一貫対応
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* ドローンスクール */}
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="mb-6">
              <img 
                alt="ドローンスクール" 
                className="w-full h-64 object-cover rounded-lg" 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/0ea6f07708071a506b7b8a92f442beff.webp"
              />
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4">プロの操縦技術を習得</h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed mb-6">
              最短3日で資格取得。卒業後もグループのネットワークで、あなたの農業を継続的にサポートします。
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>農業ドローン協議会認定スクール</span>
              </li>
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>オンライン講習なら、最短3日で資格取得可能</span>
              </li>
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>実機を使った実践的な講習</span>
              </li>
            </ul>
            <button 
              onClick={() => handleNavigation('/school')}
              className="w-full py-3 bg-[#76B947] text-white rounded-lg hover:bg-[#2A6041] transition-colors font-semibold sm:text-lg whitespace-nowrap cursor-pointer"
            >
              ドローンスクール詳細へ
            </button>
          </div>

          {/* 整備・サポート */}
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="mb-6">
              <img 
                alt="整備・サポート" 
                className="w-full h-64 object-cover rounded-lg" 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/aaa9c03d0ad2d402935524a73d6fce5a.webp"
              />
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4">万全のアフターサポート</h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed mb-6">
              定期点検や修理はもちろん、繁忙期の散布代行（請負）まで、お気軽にご相談ください。
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>定期点検・整備サービス</span>
              </li>
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>急なトラブル対応</span>
              </li>
              <li className="flex items-center text-gray-600 sm:text-lg">
                <i className="ri-check-line text-[#76B947] mr-2"></i>
                <span>散布代行（請負）サービス</span>
              </li>
            </ul>
            <button 
              onClick={handleNavigateToMaintenance}
              className="w-full py-3 bg-[#76B947] text-white rounded-lg hover:bg-[#2A6041] transition-colors font-semibold sm:text-lg whitespace-nowrap cursor-pointer"
            >
              サポート詳細へ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchoolSupportSection;
